import { useEffect } from "react";

let lockCount = 0;
let savedBodyStyles = null;
let savedScrollY = 0;

const lockBodyScroll = () => {
    if (lockCount === 0) {
        const { body, documentElement } = document;
        savedScrollY = window.scrollY || window.pageYOffset || 0;
        savedBodyStyles = {
            overflow: body.style.overflow,
            position: body.style.position,
            top: body.style.top,
            width: body.style.width,
            paddingRight: body.style.paddingRight,
        };

        const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
        body.style.overflow = "hidden";
        body.style.position = "fixed";
        body.style.top = `-${savedScrollY}px`;
        body.style.width = "100%";
        if (scrollbarWidth > 0) {
            body.style.paddingRight = `${scrollbarWidth}px`;
        }
    }

    lockCount += 1;
};

const unlockBodyScroll = () => {
    lockCount = Math.max(lockCount - 1, 0);
    if (lockCount > 0 || !savedBodyStyles) return;

    const { body } = document;
    body.style.overflow = savedBodyStyles.overflow;
    body.style.position = savedBodyStyles.position;
    body.style.top = savedBodyStyles.top;
    body.style.width = savedBodyStyles.width;
    body.style.paddingRight = savedBodyStyles.paddingRight;
    window.scrollTo(0, savedScrollY);

    savedBodyStyles = null;
    savedScrollY = 0;
};

const useBodyScrollLock = (enabled = true) => {
    useEffect(() => {
        if (!enabled) return undefined;

        lockBodyScroll();
        return unlockBodyScroll;
    }, [enabled]);
};

export default useBodyScrollLock;
